export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const EMAIL_VALIDATION_MESSAGE = "Please enter a valid email address";

export const EMAIL_VALIDATION = {
  required: "Email is required",
  pattern: {
    value: EMAIL_REGEX,
    message: EMAIL_VALIDATION_MESSAGE,
  },
};

export const isValidEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email);
};
